import { defineComponent as _defineComponent } from 'vue'
import pie from '@/components/charts/pie.vue';
import bar from '@/components/charts/bar.vue';
import line1 from '@/components/charts/line.vue';
import list from '@/components/charts/list.vue';
import lastRead from "@/views/last-read/index.vue";
import { onMounted, ref, computed } from 'vue';
import { config, userConfig } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const pieRef = ref();

const indexViewDic = {
    '4k': ['pie', 'bar', 'line', 'list', 'last-read'],
    '2k': ['pie', 'bar', 'line', 'list', 'last-read'],
    large: ['pie', 'bar', 'line', 'list', 'last-read'],
    middle: ['pie', 'bar', 'line', 'list', 'last-read'],
    tablet: ['pie', 'bar', 'line', 'list', 'last-read'],
    small: ['bar', 'line', 'last-read'],
    mini: ['bar', 'line', 'last-read'],
}

const layoutLimit = computed(() => (key: string) => {
    const screen = config.screenType;
    let layoutArr = indexViewDic[screen];

    return layoutArr.includes(key);
});

onMounted(() => {

    if (!pieRef.value) return;
    window.addEventListener('resize', pieRef.value.resize());
})

const __returned__ = { pieRef, indexViewDic, layoutLimit, pie, bar, line1, list, lastRead }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})